import React from 'react';

const ScrollToTopButton = () => {

  return (
    <>
        {/* scroll to top */}
        <button className="scroll-top scroll-to-target" data-target="html">
            <i className="fal fa-long-arrow-up"></i>
        </button>
    </>
    );
  }
  
  export default ScrollToTopButton;